import Link from 'next/link';
import { useRouter } from 'next/router';
import { showConsentOnPage } from '../../utils/consent-utils';
import { BFIslandButton, BFIslandColors } from '@buzzfeed/react-components';
import styles from './index.module.scss';
import { ITUNES_APP_URL } from '../../constants';
import instagramIcon from '../../public/static/images/social-2.svg';
import tiktokIcon from '../../public/static/images/social-3.svg';
import islandLogo from '../../public/static/images/islandLogo.svg';
import downloadOnAppStore from '../../public/static/images/downloadOnAppStore.svg';

const SocialIcons = () => (
  <div className={styles.socialIcons}>
    <a
      href="https://www.instagram.com/bfisland"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="BF Island on Instagram"
      className={styles.socialLink}
    >
      <img src={instagramIcon} alt="" width={24} height={24} />
    </a>
    <a
      href="https://www.tiktok.com/@bf.island"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="BF Island on TikTok"
      className={styles.socialLink}
    >
      <img src={tiktokIcon} alt="" width={24} height={24} />
    </a>
  </div>
);

const AppStoreBadge = () => (
  <a
    href={ITUNES_APP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Download on the App Store"
  >
    <img
      src={downloadOnAppStore}
      alt="Download on the App Store"
      className={styles.appStoreBadge}
    />
  </a>
);

const ConsentControls = () => (
  <>
    <div className={styles.gdprConsentModule}>
      <button
        className={`${styles.consentButton} ot-sdk-show-settings ot-sdk-btn`}
        id="ot-sdk-btn"
        onClick={() => {
          // eslint-disable-next-line new-cap
          if (window.OneTrust?.ToggleInfoDisplay) {
            window.OneTrust.ToggleInfoDisplay();
          }
        }}
      >
        Manage Preferences
      </button>
    </div>
    <div className={styles.ccpaConsentModule}>
      <button
        className={`${styles.consentButton} ot-sdk-show-settings ot-sdk-btn`}
        id="ot-sdk-btn"
        onClick={() => {
          // eslint-disable-next-line new-cap
          if (window.OneTrust?.ToggleInfoDisplay) {
            window.OneTrust.ToggleInfoDisplay();
          }
        }}
      >
        Do not sell or share my personal information
      </button>
    </div>
  </>
);

const LegalLinks = ({ showConsent }) => (
  <div className={styles.legalLinks}>
    <div className={styles.legalRow}>
      <Link href="/privacypolicy">
        <a className={styles.legalLink}>Privacy policy</a>
      </Link>
      {' | '}
      <Link href="/user-agreement">
        <a className={styles.legalLink}>User agreement</a>
      </Link>
    </div>
    {showConsent && <ConsentControls />}
  </div>
);

const Footer = () => {
  const router = useRouter();
  const showConsent = showConsentOnPage(router.pathname);
  const isHomepage = router.pathname === '/';

  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={styles.mobileContent}>
        <SocialIcons />
        <div className={styles.legalRow}>
          <Link href="/privacypolicy">
            <a className={styles.legalLink}>Privacy policy</a>
          </Link>
          {' | '}
          <Link href="/user-agreement">
            <a className={styles.legalLink}>User agreement</a>
          </Link>
        </div>
        {showConsent && <ConsentControls />}
      </div>

      <div className={styles.desktopContent}>
        <div className={styles.leftCol}>
          <SocialIcons />
        </div>
        <div className={styles.centerCol}>
          {isHomepage ? (
            <>
              <BFIslandButton
                text="Get BF Island"
                size="medium"
                fullWidth
                bgColor={BFIslandColors.LIME}
                onClick={() => window.open(ITUNES_APP_URL, '_blank', 'noopener,noreferrer')}
              />
              <AppStoreBadge />
            </>
          ) : (
            <>
              <img src={islandLogo} alt="BF Island" className={styles.islandLogo} />
              <AppStoreBadge />
            </>
          )}
        </div>
        <div className={styles.rightCol}>
          <LegalLinks showConsent={showConsent} />
        </div>
      </div>
    </footer>
  );
};

export default Footer;